import React from 'react';
import { Routes, Route } from 'react-router-dom';
import MainLayout from './layouts/MainLayout';
import AdminLayout from './layouts/AdminLayout';
import ProtectedRoute from './components/ProtectedRoute';

// Public Pages
import Home from './pages/Home';
import About from './pages/About';
import News from './pages/News';
import Workshops from './pages/Workshops';
import Outreach from './pages/Outreach';
import Team from './pages/Team';
import Gallery from './pages/Gallery';
import Donate from './pages/Donate';
import Contact from './pages/Contact';

// Admin Pages
import Login from './pages/admin/Login';
import HomeAdmin from './pages/admin/HomeAdmin';
import AboutAdmin from './pages/admin/AboutAdmin';
import NewsAdmin from './pages/admin/NewsAdmin';
import WorkshopsAdmin from './pages/admin/WorkshopsAdmin';
import OutreachAdmin from './pages/admin/OutreachAdmin';
import TeamAdmin from './pages/admin/TeamAdmin';
import GalleryAdmin from './pages/admin/GalleryAdmin';
import DonateAdmin from './pages/admin/DonateAdmin';
import ContactAdmin from './pages/admin/ContactAdmin';
import UsersAdmin from './pages/admin/UsersAdmin';

function App() {
  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/" element={<MainLayout />}>
        <Route index element={<Home />} />
        <Route path="about" element={<About />} />
        <Route path="news" element={<News />} />
        <Route path="workshops" element={<Workshops />} />
        <Route path="outreach" element={<Outreach />} />
        <Route path="team" element={<Team />} />
        <Route path="gallery" element={<Gallery />} />
        <Route path="donate" element={<Donate />} />
        <Route path="contact" element={<Contact />} />
      </Route>

      {/* Admin Routes */}
      <Route path="/admin/login" element={<Login />} />
      
      <Route path="/admin" element={<ProtectedRoute allowedRoles={['admin', 'superAdmin']} />}>
        <Route element={<AdminLayout />}>
          <Route index element={<div style={{textAlign:'center', marginTop:'5rem'}}><h1>Welcome to CMS</h1><p>Select a module from the sidebar to manage content.</p></div>} />
          <Route path="home" element={<HomeAdmin />} />
          <Route path="about" element={<AboutAdmin />} />
          <Route path="news" element={<NewsAdmin />} />
          <Route path="workshops" element={<WorkshopsAdmin />} />
          <Route path="outreach" element={<OutreachAdmin />} />
          <Route path="team" element={<TeamAdmin />} />
          <Route path="gallery" element={<GalleryAdmin />} />
          <Route path="donate" element={<DonateAdmin />} />
          <Route path="contact" element={<ContactAdmin />} />
          
          {/* Super Admin Only */}
          <Route element={<ProtectedRoute allowedRoles={['superAdmin']} />}>
             <Route path="users" element={<UsersAdmin />} />
          </Route>
        </Route>
      </Route>
    </Routes>
  );
}

export default App;
